// import * as http from '../require'
import http from '../require'
// 获取图形验证码
export const captcha = data => http.post('/v1/health/uc/session/captcha/request', data)
// 密码登录
export const userLogin = data => http.post('/v1/health/uc/session/login', data)
// 短信验证码登录
export const smscode_login = data => http.post('/v1/sqgj/uc/session/smscode_login', data)
// 获取短信验证码
export const request_sms_code = data => http.post('/v1/sqgj/uc/session/captcha/request_sms_code', data)
// 退出登录
export const exitLogin = data => http.delete('/v1/health/uc/session/logout', data)
// 修改密码
export const modify_password = data => http.put('/v1/health/uc/user/update_password', data)
export const updatePersonPassword = data => http.post('/video_learning/updatePersonPassword', data)
// 登录成功调用
export const loginSuccess = data => http.post('/video_learning/person/loginSuccess', data)
// 判断用户登录信息 是学生还是老师还是未登录
export const getSessionPerson = data => http.post('/video_learning/getSessionPerson', data)
// 获取小程序二维码
export const getWechatQrcode = data => http.get('/v1/health/uc/ticket_session/request_wechat_qrcode', data)
// 刷新微信ticket
export const refreshTicket = data => http.get('/v1/health/uc/ticket_session/refresh_wechat_ticket', data)
/** 获取区县数据 */
export const getAddressTree = () => http.get('/v1/health/web/zone/tree')

export const getSchoolList = (params) => http.post('/v1/health/web/school/page', params)

export const registerUser = (data) => http.post('/v1/health/web/user/regist', data)
